
import { getArgsAsTypesafeObjectProperties } from '../constants-util';

export const constants = getArgsAsTypesafeObjectProperties(
    'CREATE_UNIT_WEIGHT',
    'GET_UNIT_WEIGHT',
    'UPDATE_UNIT_WEIGHT_ID',
    'DELETE_UNIT_WEIGHT',
);
